import React, { FunctionComponent, useEffect, useState } from 'react';
import grey from '@material-ui/core/colors/grey';
import { makeStyles, createStyles, Button, Box, Grid, Theme } from '@material-ui/core';
import { Contact, ContactType } from '../../../../store/modules/person/types';
import { Form } from '../../../../store/modules/application/types';
import Loader from '../../../../components/Loader';
import FormFieldDisplay from '../../../../components/FormDisplay/FormFieldDisplay';
import { extractFormData, restoreRecord } from '../../../../components/FormDisplay/FormDisplay';

type PersonContactDialogProps = {
    personId: string;
    isEditModalOpen: boolean;
    setModalStatus: Function;
    addPersonContact: Function;
    updatePersonContact: Function;
    selectedPersonContactDetail: Contact;
    contactTypes: ContactType[];
    addPersonForm: Form;
    isLoading: boolean;
    getContactTypes: Function;
    getAddContactForm: Function;
};

const PersonContactDialog: FunctionComponent<PersonContactDialogProps> = (props) => {
    const useStyles = makeStyles((theme: Theme) =>
        createStyles({
            addPersonContactDialog: {
                display: 'flex',
                flexGrow: 1,
            },
            addPersonContactDialogLabel: {
                fontSize: 14,
                fontWeight: 500,
                color: theme.palette.text.secondary,

                textAlign: 'end',
                justifyContent: 'flex-end',
                width: '100%',
                lineHeight: '21px',
                paddingRight: '20px',
                display: 'flex',
            },
            addPersonContactDialogCommentLabel: {
                fontSize: 14,
                fontWeight: 500,
                color: theme.palette.text.secondary,

                textAlign: 'end',
                justifyContent: 'flex-end',
                width: '100%',
                lineHeight: '21px',
                paddingRight: '20px',
                display: 'flex',
                paddingTop: '17px',
            },
            adddInspectionDialogValue: {
                fontSize: 14,
                fontWeight: 450,
                color: grey[600],
                width: '100%',
                lineHeight: '21px',
            },
            addPersonContactDialogMain: {
                width: '100%',
            },
            margin: {
                margin: theme.spacing(1),
            },
            activationModal: {
                padding: 10,
            },
            modalHeader: {
                color: theme.palette.text.secondary,

                fontSize: 20,
                fontWeight: 500,
                marginBottom: 20,
            },
            modalBtn: {
                marginLeft: 20,
            },
            btnContainer: {
                marginTop: 25,
            },
            datePickerContainer: {
                backgroundColor: 'white',
                border: '1px solid #ced4da',
                borderRadius: 5,
                padding: '3px 0px 3px 10px',
                margin: '0px 0px',
            },
            datePicker: {
                margin: 0,
            },
            borderedInputs: {
                border: '1px solid #ced4da',
                padding: 5,
                borderRadius: 4,
                marginBottom: '5px',
                '&:focus': {
                    borderRadius: 4,
                    borderColor: '#80bdff',
                    boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
                },
            },
            width: {
                width: '100%',
            },
            contactTypesSelect: {
                fontSize: 13,
                border: '1px solid rgb(0,0,0,0.23) !important',
                borderRadius: 3,
                marginBottom: '5px',
                color: '#484848 !important',
                minWidth: '100%',
                height: '40px',
                padding: '5px 8px',
            },
        }),
    );

    const {
        setModalStatus,
        addPersonContact,
        isEditModalOpen,
        personId,
        selectedPersonContactDetail,
        updatePersonContact,
        getContactTypes,
        contactTypes,
        isLoading,
        addPersonForm,
        getAddContactForm,
    } = props;
    const classes = useStyles();
    useEffect(() => {
        getAddContactForm();
    }, [getAddContactForm]);

    const [formData, setFormData] = useState<Record<string, any>>({});

    const handleInputChange = (dataKey: any, value: unknown) => {
        setFormData({
            ...formData,
            [dataKey]: value,
        });
    };

    useEffect(() => {
        getContactTypes();
    }, [getContactTypes]);

    useEffect(() => {
        if (isEditModalOpen) {
            if (addPersonForm) {
                const formattedContactRecord = extractFormData(selectedPersonContactDetail, addPersonForm);
                setFormData(formattedContactRecord);
            }
        }
    }, [isEditModalOpen, selectedPersonContactDetail, addPersonForm]);

    const handleSelectedContactOperation = () => {
        const contactRecord = restoreRecord(
            selectedPersonContactDetail ? selectedPersonContactDetail : {},
            formData,
            addPersonForm,
        );
        const formattedRecord = {
            ...contactRecord,
            contactType: contactTypes.find((item) => item.id === contactRecord?.contactType?.id),
        };
        isEditModalOpen
            ? updatePersonContact(
                  { ...formattedRecord, id: selectedPersonContactDetail.id },
                  personId,
                  selectedPersonContactDetail.id,
              )
            : addPersonContact(formattedRecord, personId);

        setModalStatus(false);
    };
    if (isLoading) return <Loader />;
    return (
        <Box>
            <Grid container className={classes.activationModal}>
                <div className={classes.modalHeader}>{isEditModalOpen ? 'Edit Contact' : 'Add Contact'}</div>
                {addPersonForm &&
                    addPersonForm.sections.flatMap((section) =>
                        section.entries.map((entry) => (
                            <Grid key={entry.field} container style={{ marginTop: '10px', width: '100%' }}>
                                <Grid key={entry.field} item style={{ alignItems: 'center', width: '100%' }}>
                                    <FormFieldDisplay
                                        formData={formData}
                                        formField={entry}
                                        value={formData[entry.field]}
                                        readOnly={false}
                                        handleInputChange={handleInputChange}
                                        isCustomStyle={true}
                                    />
                                </Grid>
                            </Grid>
                        )),
                    )}
            </Grid>

            <Grid className={classes.btnContainer} sm={12} md={12} lg={12} item>
                <Box display="flex" justifyContent="flex-end">
                    <Button
                        onClick={() => {
                            setModalStatus(false);
                        }}
                        className={classes.modalBtn}
                    >
                        CANCEL
                    </Button>
                    <Button
                        className={classes.modalBtn}
                        onClick={handleSelectedContactOperation}
                        variant="contained"
                        color="primary"
                    >
                        {isEditModalOpen ? 'UPDATE' : 'ADD'}
                    </Button>
                </Box>
            </Grid>
        </Box>
    );
};

export default PersonContactDialog;
